export default function Auth ({ next }){
	return window.user ? next() : next({ name: 'auth.login' });
}
